module.exports = __webpack_public_path__ + "img/step4.0b8b3198.png";